import React from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'

function Testers() {
    return (
        <section className="flex flex-col min-h-screen">
            <Header />
            <main className='flex-grow w-full max-w-[1200px] self-center p-5 lg:p-10 mb-10'>
                <section className='flex flex-col gap-10'>
                    <article className='flex flex-col md:flex-row gap-5 lg:gap-10 items-center'>
                        <div className='w-full md:w-2/3 flex flex-col gap-5 text-start'>
                            <h1 className='text-xl lg:text-3xl text-center'>¿Que son los perfumes <strong>tester</strong>?</h1>
                            <p className='text-sm lg:text-base'>Los <strong>perfumes tester</strong> son aquellos que los fabricantes suministran a retailers como Saga Falabella, Ripley, Oechsle, Perfumerías Unidas, entre otros, con el objetivo de que los clientes puedan probar la fragancia antes de comprarla.</p>
                            <p className='text-sm lg:text-base'>Al tratarse de productos 'tester', no requieren empaques sellados ni con el diseño de un producto comercializado, y suelen venir en cajas blancas. Esto contribuye a una reducción en su costo.</p>
                        </div>
                        <img src='/Perfume_tester.webp' className='w-2/3 md:w-1/3' />
                    </article>
                    <article className='flex flex-col gap-5 py-10'>
                        <h3 className='text-xl lg:text-3xl font-semibold'>¿Qué opinan sobre los perfumes tester?</h3>
                        <section className='flex flex-col xl:flex-row gap-20 xl:gap-10 py-0 xl:py-10 w-full'>
                            <article className='w-full h-full flex flex-col gap-5'>
                                <div className='h-full min-h-16 xl:min-h-24 flex flex-col gap-2 justify-center'>
                                    <h4 className='text-lg lg:text-xl'>¿Qué es un perfume TESTER?</h4>
                                    <a className='font-medium text-blue-600 dark:text-blue-500 hover:underline' rel='noreferrer' href='https://www.tiktok.com/@jcparfums' target='_blank'>@jcparfums</a>
                                </div>
                                <iframe
                                    className='w-fit h-full aspect-[9/17] self-center'
                                    src="https://www.tiktok.com/embed/7302912274224647429"
                                    allowfullscreen
                                    scrolling="no"
                                    allow="encrypted-media;"
                                ></iframe>
                            </article>
                            <article className='w-full h-full flex flex-col gap-5'>
                                <div className='h-full min-h-16 xl:min-h-24 flex flex-col gap-2 justify-center'>
                                    <h4 className='text-lg lg:text-xl'>Diferencia entre un perfume TESTER y uno de línea</h4>
                                    <a className='font-medium text-blue-600 dark:text-blue-500 hover:underline' rel='noreferrer' href='https://www.tiktok.com/@elgueydelosperfumes' target='_blank'>@elgueydelosperfumes</a>
                                </div>
                                <iframe
                                    className='w-fit h-full aspect-[9/17] self-center'
                                    src="https://www.tiktok.com/embed/7218001723300859142"
                                    allowfullscreen
                                    scrolling="no"
                                    allow="encrypted-media;"
                                ></iframe>
                            </article>
                            <article className='w-full h-full flex flex-col gap-5'>
                                <div className='h-full min-h-16 xl:min-h-24 flex flex-col gap-2 justify-center'>
                                    <h4 className='text-lg lg:text-xl'>3 Mitos de los perfumes TESTER</h4>
                                    <a className='font-medium text-blue-600 dark:text-blue-500 hover:underline' rel='noreferrer' href='https://www.tiktok.com/@rossperfumes' target='_blank'>@rossperfumes</a>
                                </div>
                                <iframe
                                    className='w-fit h-full aspect-[9/17] self-center'
                                    src="https://www.tiktok.com/embed/7216899594570042630"
                                    allowfullscreen
                                    scrolling="no"
                                    allow="encrypted-media;"
                                ></iframe>
                            </article>
                        </section>
                    </article>
                    <article className='self-center'>
                        <div className='flex flex-col gap-2 lg::gap-5 text-start'>
                            <h2 className='text-xl lg:text-3xl text-center font-semibold'>Diferencias entre un perfume tester y un perfume sellado</h2>
                            <p className='text-sm lg:text-base'>La diferencia que notaras a simple vista es que los perfumes Tester se distribuyen en una caja blanca o marrón unicamente con el logotipo de la marca.</p>
                            <p className='text-sm lg:text-base'>Algunos perfumes vienen sin tapa si es muy grande, de forma que las cajas puedan ser mas compactas.</p>
                            <div className='flex items-center justify-center gap-10 w-full sm:w-2/3 self-center mb-5'>
                                <figure className='h-full flex flex-col items-center'>
                                    <img src='/Perfume_tester_sin_tapa.webp' className="h-auto max-h-[300px] aspect-square object-contain" />
                                    <figcaption className='text-xs italic'>Perfume tester sin tapa</figcaption>
                                </figure>
                                <figure className='h-full flex flex-col items-center'>
                                    <img src='/Batch_code.webp' className="h-auto max-h-[300px] aspect-square object-contain" />
                                    <figcaption className='text-xs italic'>Batch Code</figcaption>
                                </figure>
                            </div>
                            <p className='text-sm lg:text-base'>No existe otra diferencia, el envase y el contenido es el mismo que un perfume sellado.</p>
                            <p className='text-sm lg:text-base'>Al igual que un perfume sellado este viene con Batch Code que identifica la originalidad del perfume, tanto en la caja como en el frasco los cuales deben coincidir.</p>
                            <p className='text-sm lg:text-base'>Puedes verificar el Batch Code <a href='https://www.checkfresh.com/' rel='noreferrer' target='_blank' className='font-medium text-blue-600 dark:text-blue-500 hover:underline'>aquí.</a></p>
                        </div>
                    </article>
                </section>
            </main>
            <Footer />
        </section>
    )
}

export default Testers